module.exports = __webpack_public_path__ + "media/images/redesign-images/how-it-works/icons/icon-speech-bubble-d7a14c853c57071f5bbb4ade0b1265d3.svg";